import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
	list: [],
	category: null,
	error: "",
	loading: false,
};

// ADD_category
export const addCategory = createAsyncThunk(
	"category/addCategory",
	async (values) => {
		try {
			const { data } = await axios({
				method: "post",
				url: `category/`,
				data: {
					...values,
				},
			});
			toast.success("Category added successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in adding Category try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

// DELETE_category
export const deleteCategory = createAsyncThunk(
	"category/deleteCategory ",
	async (id) => {
		try {
			const resp = await axios({
				method: "delete",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `category/${id}`,
			});

			toast.success("Category deleted successfully!");
			return {
				data: resp.data.id,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in deleting category try again");
			console.log(error.message);
		}
	}
);

// category_DETAILS
export const loadSinglePublicHoliday = createAsyncThunk(
	"category/loadSinglePublicHoliday",
	async (id) => {
		try {
			const data = await axios.get(`category/${id}`);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

// categoryS
export const getAllCategory = createAsyncThunk(
	"category/getAllCategory",
	async () => {
		try {
			const { data } = await axios.get(`category/`);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

export const updateCategory = createAsyncThunk(
	"category/updateCategory",
	async ({ id, values }) => {
		try {
			const { data } = await axios({
				method: "put",

				url: `category/${id}`,
				data: {
					...values,
				},
			});
			toast.success("Category updated successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in updating Category try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

const categorySlice = createSlice({
	name: "category",
	initialState,
	reducers: {
		clearCategory: (state) => {
			state.category = null;
		},
	},
	extraReducers: (builder) => {
		// 1) ====== builders for getAllCategory ======

		builder.addCase(getAllCategory.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(getAllCategory.fulfilled, (state, action) => {
			state.loading = false;
			state.list = action.payload;
		});

		builder.addCase(getAllCategory.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 2) ====== builders for addCategory  ======

		builder.addCase(addCategory.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(addCategory.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(addCategory.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});




		// 3) ====== builders for category ======

		builder.addCase(updateCategory.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(updateCategory.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(updateCategory.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 4) ====== builders for deleteCategory  ======

		builder.addCase(deleteCategory.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(deleteCategory.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(deleteCategory.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});
	},
});

export default categorySlice.reducer;
export const { clearCategory } = categorySlice.actions;
